import { createAsyncThunk } from '@reduxjs/toolkit';
import { CompanyService } from '../../epics/company';
import { CompanyAllService } from '../../epics/company/all';
import {
    addCompanyKey,
    checkautoCompanyAllListKey,
    companyAllKey,
    companyAllListKey,
    companyKey,
    companyListKey,
    deleteCompanyKey,
    editCompanyKey,
    advertsListKey,
} from './companyKeys';
import { clearCompanyKey } from '../common/thunkKeys/commonInfoKeys';
import { clearTypeCorporate } from '../common/common_reducers/typeCorporate';
import { getTypeCorporate } from '../common/thunks/commonInfoThunks';

export const addCompany = createAsyncThunk(
    addCompanyKey,
    async (companyData, thunkAPI) => {
        try {
            return await CompanyService.addCompany(companyData);
        } catch (error) {
            return thunkAPI.rejectWithValue({
                message: error?.message || error?.error || 'unknown',
                details: error?.details || null,
            });
        }
    },
);

export const getCheckautoCompanyAllList = createAsyncThunk(
    checkautoCompanyAllListKey,
    async (payload, thunkAPI) => {
        try {
            const response =
                await CompanyAllService.getCheckautoCompanyAllList(payload);
            return response;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    },
);

export const getCompanyAll = createAsyncThunk(
    companyAllKey,
    async (id, thunkAPI) => {
        try {
            const response = await CompanyAllService.getCompanyAll(id);
            return response;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    },
);

export const getCompanyAllList = createAsyncThunk(
    companyAllListKey,
    async (payload, thunkAPI) => {
        try {
            const response = await CompanyAllService.getCompanyAllList(payload);
            return response;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    },
);

export const getCompanyList = createAsyncThunk(
    companyListKey,
    async (payload, thunkAPI) => {
        try {
            const response = await CompanyService.getCompanyList(payload);
            return response;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    },
);

export const getCompany = createAsyncThunk(companyKey, async (id, thunkAPI) => {
    try {
        const response = await CompanyService.getCompany(id);
        return response;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.message);
    }
});

export const editCompany = createAsyncThunk(
    editCompanyKey,
    async (updates, thunkAPI) => {
        try {
            const response = await CompanyService.editCompany(updates);
            return response;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    },
);

export const deleteCompany = createAsyncThunk(
    deleteCompanyKey,
    async (id, thunkAPI) => {
        try {
            const response = await CompanyService.deleteCompany(id);
            return response;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    },
);

export const clearCompanyDataAction = createAsyncThunk(
    clearCompanyKey,
    (_, { dispatch }) => {
        dispatch(clearTypeCorporate());

        dispatch(getTypeCorporate());
    },
);

export const getAdvertsList = createAsyncThunk(
    advertsListKey,
    async (payload, thunkAPI) => {
        try {
            const response = await CompanyService.getAdvertsList(payload);
            return response;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    },
);
